import { notifyToast, retrieveErrorFromApi } from '../../../helper'
import { setAppErrors } from '../../action/system'
import { setDeliveryBeeperConfigs, setDeliverySettingsCartSettings, setDeliverySettingsChangeSettings, updateDeliverySettingsCartSetting, updateDeliverySettingsChangeSetting } from '../../action/deliverySettings'
import getExpertCartSettings from '../../axios/registration/expertCartSettings'
import updateExpertCartSettings from '../../axios/registration/expertCartSettings/put'
import getChangeSettings from '../../axios/registration/changeSettings'
import updateChangeSettings from '../../axios/registration/changeSettings/put'
import getBeeperConfigs from '../../axios/order/beeperConfigs'
import updateBeeperConfigs from '../../axios/order/beeperConfigs/put'

export const getDeliverySettingsCartSettingsThunk = (module) => dispatch => {
	return getExpertCartSettings(module)
		.then(res => {
			dispatch(setDeliverySettingsCartSettings(res.data))
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateDeliverySettingsCartSettingsThunk = (data) => dispatch => {
	return updateExpertCartSettings(data)
		.then((res) => {
			notifyToast({ message: 'Cart setting successfully updated' })
			return dispatch(updateDeliverySettingsCartSetting(res.data))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getDeliverySettingsChangeSettingsThunk = (module) => dispatch => {
	return getChangeSettings(module)
		.then(res => {
			dispatch(setDeliverySettingsChangeSettings(res.data))
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateDeliverySettingsChangeSettingsThunk = (data) => dispatch => {
	return updateChangeSettings(data)
		.then((res) => {
			notifyToast({ message: 'Change setting successfully updated' })
			return dispatch(updateDeliverySettingsChangeSetting(res.data))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getDeliverySettingsBeeperConfigsThunk = (module) => dispatch => {
	return getBeeperConfigs(module)
		.then(res => {
			dispatch(setDeliveryBeeperConfigs(res.data))
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateDeliveryBeeperConfigsThunk = (data) => dispatch => {
	return updateBeeperConfigs(data)
		.then((res) => {
			notifyToast({ message: 'Beeper setting successfully updated' })
			return dispatch(getDeliverySettingsBeeperConfigsThunk(res.data.module))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
